import RichTextEditor from "../TextEditor";
import CachedIcon from '@mui/icons-material/Cached';
import TranslateIcon from "@mui/icons-material/Translate";
import { CircularProgress, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import globalStyle from "../../globalStyle";
import Label from "../Label";
import TextInput from "../TextInputs";

const SpecificationAndDescription = ({
    inputValues,
    inputError,
    handleChangeValues,
    handleTranslateToEnglish,
    isLoading,
    handleEditorChange,
    handleGenerateSpecification,
}) => {
    const { t } = useTranslation(["products", "common"]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <Typography fontWeight={600} fontSize={20}>
                    {t("descriptionAndSpecifications")}
                </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
                <Label
                    labelText={t("descriptionInRomanian")}
                    required
                    htmlFor={"base-package-description-ro"}
                />
                <TextInput
                    id={"base-package-description-ro"}
                    styleProps={globalStyle.textField}
                    placeholder={t("enterDescriptionInRomanian")}
                    required
                    multiline
                    rows={4}
                    // textLength={255}
                    name={"description_ro"}
                    value={inputValues.description_ro}
                    onChange={handleChangeValues}
                    inputError={Boolean(inputError.description_ro)}
                    helperText={t(inputError.description_ro)}
                // InputEndIcon={
                //     <Typography variant="body2" color="text.grey">
                //         {inputValues.description_ro?.length}/255
                //     </Typography>
                // }
                />
            </Grid>

            <Grid item xs={12} md={12}>
                <Stack mb={"5px"} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Label
                        labelText={t("descriptionInEnglish")}
                        required
                        htmlFor={"base-package-description-en"}
                    />
                    <Chip
                        label={t("translateToEnglish", { ns: "common" })}
                        size="small"
                        onClick={() => handleTranslateToEnglish("description_ro", "description_en")}
                        icon={
                            isLoading.translateToEnglish ? (
                                <CircularProgress size={16} color="inherit" />
                            ) : (
                                <TranslateIcon />
                            )
                        }
                        disabled={isLoading.translateToEnglish}
                    />
                </Stack>
                <TextInput
                    id={"base-package-description-en"}
                    styleProps={globalStyle.textField}
                    placeholder={t("enterDescriptionInEnglish")}
                    required
                    multiline
                    rows={4}
                    // textLength={255}
                    name={"description_en"}
                    value={inputValues.description_en}
                    onChange={handleChangeValues}
                    inputError={Boolean(inputError.description_en)}
                    helperText={t(inputError.description_en)}
                // InputEndIcon={
                //     <Typography variant="body2" color="text.grey">
                //         {inputValues.description_en?.length}/255
                //     </Typography>
                // }
                />
            </Grid>

            <Grid item xs={12} md={12}>
                <Label
                    required
                    labelText={t("specificationInRomanian")}
                    htmlFor={"base-package-specifications-ro"}
                />
                <RichTextEditor
                    value={inputValues.specification_ro || ""}
                    onChange={(html) => handleEditorChange("specification_ro", html)}
                />
                {inputError.specification_ro && (
                    <FormHelperText error>
                        {t(inputError.specification_ro)}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={12} md={12}>
                <Stack mb={"5px"} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>

                    <Label
                        required
                        labelText={t("specificationInEnglish")}
                        htmlFor={"base-package-specifications-en"}
                    />

                    <Chip
                        label={t("generateSpecification", { ns: "common" })}
                        size="small"
                        onClick={() => handleGenerateSpecification()}
                        icon={isLoading.generateSpecification ? <CircularProgress size={16} color="inherit" /> : <CachedIcon />}
                        disabled={isLoading.generateSpecification}
                    />
                </Stack>
                <RichTextEditor
                    value={inputValues.specification_en || ""}
                    onChange={(html) => handleEditorChange("specification_en", html)}
                />
                {inputError.specification_en && (
                    <FormHelperText error>
                        {t(inputError.specification_en)}
                    </FormHelperText>
                )}
            </Grid>
           
        </Grid>
    )
}

export default SpecificationAndDescription;